import { useContractRead } from 'wagmi';
import { Abi } from 'viem';
import { CONFIG, ADDRESSES } from '../config';
import { useGetProperty, useGetRedemptionFee, useGetReclaimFee, useGetLatePenalty } from '../utils/properties';

interface UseSettingsContractProps {
  type: 'trinity' | 'entity' | 'product';
  address?: `0x${string}`;
  enabled?: boolean;
}

interface ContractReadResult<T> {
  data?: T;
  isLoading: boolean;
  error?: Error;
}

export function useSettingsContract({ type, address, enabled = true }: UseSettingsContractProps) {
  // Get the properties contract address
  const { data: propertiesAddress } = useContractRead({
    address: address,
    abi: CONFIG.TRINITY_PRODUCT_ABI.abi as Abi,
    functionName: 'properties',
    enabled: enabled && !!address,
    watch: true,
  });

  // Get basic info
  const name = useContractRead({
    address: address,
    abi: CONFIG.TRINITY_PRODUCT_ABI.abi as Abi,
    functionName: 'name',
    enabled: enabled && !!address,
  }) as ContractReadResult<string>;

  const description = useContractRead({
    address: address,
    abi: CONFIG.TRINITY_PRODUCT_ABI.abi as Abi,
    functionName: 'description',
    enabled: enabled && !!address,
  }) as ContractReadResult<string>;

  // Get properties using the consolidated utilities
  const reclaimFee = useGetReclaimFee(address, enabled && !!propertiesAddress);
  const redemptionFee = useGetRedemptionFee(address, enabled && !!propertiesAddress);
  const latePenalty = useGetLatePenalty(address, enabled && !!propertiesAddress);
  console.log('latePenalty', latePenalty);
  
  // Get trinity-specific properties
  const trinityServiceFee = useContractRead({
    address: ADDRESSES.TRINITY_MASTER,
    abi: CONFIG.TRINITY_ABI.abi as Abi,
    functionName: 'trinityMasterServiceFee',
    watch: true,
    enabled: true
  }) as ContractReadResult<bigint>;

  const isLoading = [
    name,
    description,
    trinityServiceFee
  ].some(read => read.isLoading);

  const errors = [
    name,
    description,
    trinityServiceFee
  ].map(read => read.error).filter(Boolean);

  return {
    name: name.data,
    description: description.data,
    reclaimFee,
    redemptionFee,
    latePenalty,
    trinityServiceFee: trinityServiceFee.data,
    isLoading,
    errors
  };
} 